import { render } from "./IndustryCompanyFields.vue?vue&type=template&id=c6b631b4"
import script from "./IndustryCompanyFields.vue?vue&type=script&lang=js"
export * from "./IndustryCompanyFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__